<template>
  <!--  <div :class="{container_chat: storeApiSetting.isTabletGetters}" id="container-chat" class="container-chat">-->
  <div :class="{container_chat: storeApiSetting.isTabletGetters}" id="container-chat-chat" class="container-chat"
       v-if="settingsStore.settingsGetters">
    <div v-show="!setChat" id="container-content-chat" class="container-content-chat">
      <div class="transparent-spacing"></div>
      <div class="balloon"
           v-for="(m,index) in settingsStore.messagesGetters" :key="index">
        <div class="container-single-message">
          <div class="container-content-single-chat-bot"
               :class="{container_content_single_chat_user: m.owner === 'user',reset_max_width: m.extra !== undefined && (m.extra.form || m.extra.news),container_content_single_chat_user_feedback_width:m.extra !== undefined &&  m.extra.feedback}">
            <div v-if="m.extra === undefined" v-html="m.message"></div>
            <div :class="{max_height: m.extra !== undefined && m.extra.read_more && m.extra.index === index}" v-else
                 class="container-message-more" v-html="m.message">
            </div>
            <span class="text-more" @click="m.extra.index = -1"
                  v-if="m.extra !== undefined && m.extra.read_more && m.extra.index === index">Continua a leggere</span>
            <span class="text-more" @click="m.extra.index = index"
                  v-if="m.extra !== undefined && m.extra.read_more && m.extra.index === -1">Chiudi</span>
            <div class="container-all-news" :class="{container_all_news: storeApiSetting.isMobileGetters}"
                 v-if="m.extra !== undefined && m.extra.news">
              <a :href="news.headline_href" target="_blank" :key="index" v-for="(news,index) in m.extra.news"
                 class="container-news">
                <img :class="{img_news: storeApiSetting.isMobileGetters}" class="img-news" v-if="news.img_miniature_src"
                     :src="news.img_miniature_src" alt="">
                <span class="text-news">
                  {{ news.headline }}
                </span>
              </a>
            </div>
            <Form @submit="createFeedback" v-slot="{errors}" class="container-feedback"
                  v-if="m.extra !== undefined && m.extra.feedback">
              <div class="container-icons-feedback">
                <button @mouseleave="mouseOutFeedback($event)"
                        @mouseover="mouseInFeedback($event)" type="button"
                        :class="{container_single_icon_feedback_0: objFeedback.value === 0}"
                        class="container-single-icon-feedback" @click="setFeedBack(0)">
                  <img src="../../assets/feedback/feedback_0.svg" alt="">
                </button>
                <button @mouseleave="mouseOutFeedback($event)"
                        @mouseover="mouseInFeedback($event)" type="button"
                        :class="{container_single_icon_feedback_1: objFeedback.value === 1}"
                        class="container-single-icon-feedback" @click="setFeedBack(1)">
                  <img src="../../assets/feedback/feedback_1.svg" alt="">
                </button>
                <button @mouseleave="mouseOutFeedback($event)"
                        @mouseover="mouseInFeedback($event)" type="button"
                        :class="{container_single_icon_feedback_2: objFeedback.value === 2}"
                        class="container-single-icon-feedback" @click="setFeedBack(2)">
                  <img src="../../assets/feedback/feedback_2.svg" alt="">
                </button>
                <button @mouseleave="mouseOutFeedback($event)"
                        @mouseover="mouseInFeedback($event)" type="button"
                        :class="{container_single_icon_feedback_3: objFeedback.value === 3}"
                        class="container-single-icon-feedback" @click="setFeedBack(3)">
                  <img src="../../assets/feedback/feedback_3.svg" alt="">
                </button>
                <button @mouseleave="mouseOutFeedback($event)"
                        @mouseover="mouseInFeedback($event)" type="button"
                        :class="{container_single_icon_feedback_4: objFeedback.value === 4}"
                        class="container-single-icon-feedback" @click="setFeedBack(4)">
                  <img src="../../assets/feedback/feedback_4.svg" alt="">
                </button>
                <span class="text-danger-custom">{{ errors.value }}</span>
              </div>
              <textarea placeholder="Raccontaci la tua esperienza" class="form-control"
                        v-model="objFeedback.comment"></textarea>
              <span class="text-danger-custom">{{ errors.comment }}</span>
              <button type="submit" class="btn btn-primary-custom btn-primary-custom-colors-dark btn-feedback">Invia
                feedback
              </button>
            </Form>
          </div>
          <div class="form" v-if="m.extra !== undefined">
            <form :class="'form_'+ m.extra.form.results[0].id" v-if="m.extra.form" class="form-custom"
                  @submit.prevent="sendFields(m.extra.form.results[0].id)" autocomplete="off">
              <div v-for="(form,indexF) in m.extra.form.results" :key="indexF" class="col-12">
                <div v-for="(fieldContainer, indexFC) in form.fields" :key="indexFC" class="row row-custom">
                  <div class="col p-1 m-2" v-for="(field, indexFi) in fieldContainer" :key="indexFi">
                    <p class="text-field">{{ field.name }}</p>
                    <input :required="field.is_required" :id="field.id+'input'" :type="getInputType(field.type)"
                           class="form-control col" :placeholder="field.name" :aria-label="field.name"
                           aria-describedby="basic-addon1" v-model="formData[form.id][field.id]"
                           v-if="field.type != 'mc' && field.type != 'c'">
                    <div v-else>
                      <div v-if="field.type == 'mc'">
                        {{ typeof (formData[form.id][field.id]) != 'object' ? formData[form.id][field.id] = [] : '' }}
                        <div v-for="(value, index) in field.choices.choices" :key="index" class="container-checkbox">
                          <input type="checkbox"
                                 :required="field.is_required && (formData[form.id][field.id].length < 1)"
                                 :id="field.id+'input'"
                                 v-model="formData[form.id][field.id]"
                                 class="form-check-input"
                                 :value="Object.keys(value)[0]"
                                 :key="index">
                          <label class="form-check-label" :for="field.id+'input'">
                            {{ Object.values(value)[0] }}
                          </label>
                        </div>
                      </div>
                      <div v-else>
                        <select :required="field.is_required" :id="field.id+'input'" :placeholder="field.name"
                                :aria-label="field.name" class="form-select" v-model="formData[form.id][field.id]">
                          <option :value="Object.keys(value)[0]" v-for="(value, index) in field.choices.choices"
                                  :key="index">
                            {{ Object.values(value)[0] }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button :class="'form_'+ m.extra.form.results[0].id" class="btn btn-clear" type="button"
                          @click="cleanFields(form.id)">
                    Pulisci tutto
                  </button>
                  <button :class="'form_'+ m.extra.form.results[0].id" type="submit" class="btn btn-send">
                    Invia
                  </button>
                  <button @click="annullaForm($event)" :class="'form_'+ m.extra.form.results[0].id" type="button"
                          class="btn btn-clear btn-annulla">
                    Annulla
                  </button>
                </div>
              </div>
            </form>
            <div class="container-documents" v-else-if="m.extra.documents">
              <div class="btn btn-default-responses" v-for="doc in m.extra.documents.results" :key="doc.id"
                   @click.prevent="downloadItem(({url: doc.document_file,label: doc.name}))">
                {{ doc.name }} <img class="img-downlaod" src="../../assets/shared/download.svg" alt="">
              </div>
            </div>
            <div class="container-content-single-chat-bot" v-else-if="m.extra.links">
              <a target="_blank" :href="link.href"
                 v-for="(link,index) in m.extra.links" :key="index">
                {{ link.name }}
              </a>
            </div>
            <div :class="{there_is_buttons: m.extra.default_responses.length > 0}" class="buttons"
                 v-if="m.extra.default_responses">
              <button :id="indexBtn" :class="'btn-default-responses-'+indexBtn" class="btn btn-default-responses"
                      type="button"
                      @click="sendButton($event,btn)" v-for="(btn,indexBtn) in m.extra.default_responses"
                      :key="indexBtn">
                {{ btn }}
              </button>
            </div>
            <div class="container-embedded" v-if="m.extra.youtube_video_id">
              <iframe
                  :src="'https://www.youtube.com/embed/' + m.extra.youtube_video_id"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen>
              </iframe>
            </div>
            <div class="container-embedded" v-if="m.extra.embedded_map">
              <iframe
                  frameborder="0" style="border:0"
                  referrerpolicy="no-referrer-when-downgrade"
                  :src="getEmbeddedMapSrc(m.extra.embedded_map)"
                  allowfullscreen>
              </iframe>
            </div>
            <!--            start news with overflow-->
            <!--            <div class="container-news-mobile"-->
            <!--                 v-if="m.extra !== undefined && m.extra.news && storeApiSetting.isMobileGetters">-->
            <!--              <div class="container-content-news-mobile">-->
            <!--                <a :href="news.headline_href" target="_blank" :key="index" v-for="(news,index) in m.extra.news"-->
            <!--                   class="container-single-news-mobile">-->
            <!--                  <div style="display: flex;align-items: center;height: 100%;">-->
            <!--                    <img src="../../assets/chat/news-mobile.svg" alt="">-->
            <!--                    <span class="text-headline">{{ news.headline }}</span>-->
            <!--                  </div>-->
            <!--                </a>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            end news with overflow-->


            <!--            start default responses with overflow-->
            <!--            <div class="container-default-responses-mobile"-->
            <!--                 v-if="m.extra !== undefined && m.extra.default_responses && m.extra.default_responses.length > 0 && storeApiSetting.isMobileGetters">-->
            <!--              <div class="container-content-default-response-mobile">-->
            <!--                <button :id="indexBtn" :class="'btn-default-responses-'+indexBtn"-->
            <!--                        class="btn btn-default-responses btn-default-responses-mobile"-->
            <!--                        type="button"-->
            <!--                        @click="sendButton($event,btn)" v-for="(btn,indexBtn) in m.extra.default_responses"-->
            <!--                        :key="indexBtn">-->
            <!--                  {{ btn }}-->
            <!--                </button>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            end default responses with overflow-->
          </div>
        </div>
      </div>

      <!-- <div class="container-button-spids" :class="{'container_button_spids': boolSpid}">
        <button class="btn btn-spid" @click="showedSpid" v-if="boolSpid">
          <img src="../../assets/chat/user_spid.svg" alt="">
          Login con spid
        </button>
        <button class="btn btn-spid" v-if="boolSpid">
          <img src="../../assets/chat/cie.svg" alt="">
          Login con CIE
        </button>
      </div>
      -->

      <div class="container-content-single-chat-bot" v-if="spinner && !storeIntent.errorNetworkIntentGetters">Sta
        scrivendo ...
      </div>
      <div v-if="storeIntent.errorNetworkIntentGetters" class="container-error-network">
        <img src="../../assets/chat/errorNetwork.svg" alt="">
        errore di connessione, riprovare più tardi
      </div>
      <div v-if="errorPermissions" class="container-error-network">
        <img v-if="typePermissions === 'microphone'" src="../../assets/chat/error_microphone.svg" alt="">
        <img v-else-if="typePermissions === 'position'" src="../../assets/chat/position.svg" alt="">
        <div id="text-error"></div>
        <img @click="errorPermissions = false" role="button" style="margin: 0px 0px 0px auto" src="../../assets/chat/close.svg"
             alt="">
      </div>
    </div>
    <Form :class="{form_with_chat_hide: setChat}" class="form-container" autocomplete="off" @submit="onSubmit"
          v-slot="{  }">

      <div v-if="!showActions" class="container-more">
        <img v-b-tooltip.hover.top="'Mostra più azioni'" @click="showActions = true" src="../../assets/chat/more.svg"
             alt="">
      </div>
      <div :class="{isOpen: showActions}" id="container-actions" class="container-actions">
        <div class="container-content-actions" v-show="showActions">
          <img v-show="!setChat" @click="setChat = true" v-b-tooltip.hover.top="'Nascondi chat'"
               src="../../assets/chat/chat.svg" alt="">
          <img v-show="setChat" @click="setChat = false" v-b-tooltip.hover.top="'Mostra chat'"
               src="../../assets/chat/chat_active.svg" alt="">

          <img v-show="!setMute" @click="setterMute(true)" v-b-tooltip.hover.top="'Disattiva audio'"
               src="../../assets/chat/mute.svg" alt="">
          <img v-show="setMute" @click="setterMute(false)" v-b-tooltip.hover.top="'Riattiva audio'"
               src="../../assets/chat/mute_active.svg" alt="">

          <div class="container-gender-voice"
               v-if="settingsStore.systemSettingsGetters.user_can_change_gender.value === 'true'">
            <img @click="updateSetting('m')" @mouseover="setColor" @mouseout="resetColor" class="avatar_gender"
                 v-b-tooltip.hover.top="'Avatar Uomo'"
                 v-if="settingsStore.genderGetters === 'f'" src="../../assets/chat/avatar_M.svg" alt="">

            <img @click="updateSetting('f')" @mouseover="setColor" @mouseout="resetColor" class="avatar_gender"
                 v-b-tooltip.hover.top="'Avatar Donna'"
                 v-else-if="settingsStore.genderGetters === 'm'" src="../../assets/chat/avatar_F.svg" alt="">

            <img v-b-tooltip.hover.top="'Cambia voce'" v-if="!showVoice" id="img-voice" @click="showVoice = true"
                 src="../../assets/chat/voice.svg" alt="">
            <img v-else id="img-voice" @click="showVoice = false" src="../../assets/chat/voice_active.svg" alt="">
            <div :class="{container_menu: showVoice}" v-show="showVoice" id="container-custom-radio-button"
                 class="container-custom-radio-button">
              <b-form-radio-group
                  @change="changeVoice"
                  class="form-check-label-voice"
                  id="radio-group-1"
                  v-model="voiceSelected"
                  :options="optionsVoice"
                  name="radio-options">
              </b-form-radio-group>
            </div>
          </div>

          <img class="img-close" @click="resetAllActions" src="../../assets/chat/close.svg" alt="">
        </div>
      </div>
      <div class="form-group form-group-custom">
        <Field v-model="nome" v-slot="{ field }" name="nome" type="text" class="form-control">
          <button v-show="microphoneSupported" class="btn btn-audio record" type="button">
            <img id="start" v-show="!setAudio" src="../../assets/chat/audio.svg" alt="">
            <img id="stop" v-show="setAudio" src="../../assets/chat/audio_active.svg"
                 alt="">
          </button>
          <button v-show="!microphoneSupported" v-b-tooltip.hover.top="'Microfono non supportato dal broswer'"
                  class="btn btn-audio" type="button">
            <img src="../../assets/chat/audio.svg" alt="">

          </button>
          <input maxlength="256" id="final" :disabled="!canWrite" src="../../assets/form/send.svg"
                 placeholder="Chiedimi qualcosa"
                 class="form-control form-control-chat"
                 type="text" v-bind="field">
          <button class="btn btn-submit" type="submit">
            <img src="../../assets/form/send.svg" alt="">
          </button>
        </Field>
      </div>
    </Form>
  </div>
  <!--  </div>-->
</template>

<script>
import {useSettings} from "@/stores/settings";
import {useFormStore} from "@/stores/forms";
import {Field, Form} from 'vee-validate'
import {object, string} from "yup";
import axios from "axios";
import {KJUR} from "jsrsasign";
import {useIntentStore} from "@/stores/intents";
import {useAuthStore} from "@/stores/auth";
import {useDocumentStore} from "@/stores/documents";
import {useApiSettingStore} from "@/stores/apiSettings";
import {useUtilsStore} from "@/stores/utils";
import {useFeedbackStore} from "@/stores/feedback";
// import {v4 as uuidv4} from "uuid";

export default {
  name: "ComponentChatAs",
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names,vue/no-unused-components
    Form,
    // eslint-disable-next-line
    Field
  },
  setup() {
    const storeApiSetting = useApiSettingStore()
    const settingsStore = useSettings()
    const storeIntent = useIntentStore()
    settingsStore.messages = []
    return {
      storeApiSetting,
      settingsStore,
      storeIntent
    }
  },
  data() {
    return {
      canWrite: false,
      userPosition: null,
      optionsVoice: [],
      voiceSelected: "it-IT-Wavenet-B",
      // boolSpid: false,
      nome: '',
      lastNome: '',
      spinner: false,
      showVoice: false,
      showActions: false,
      setChat: false,
      setAudio: false,
      setMute: false,
      allowRequest: true,
      publicKey: '',
      sendRequest: false,
      objBuild: {},
      objReceive: null,
      token: undefined,
      tokenInterval: undefined,
      languageCode: "it",
      schema: object(),
      formData: {},
      confirmToSpeak: false,
      snd: null,
      boolcustom: false,
      arrayBoolDefaultResponses: [],
      color: '#99A6AA',
      lastIntent: null,
      lastFulfillmentMessages: [],
      feedback: false,
      objFeedback: {
        value: null,
        comment: ""
      },
      recordBtn: null,
      recognition: null,
      errorPermissions: false,
      messageErrorPermissions: '',
      typePermissions: '',
      microphoneSupported: true
    }
  },
  created() {
    this.getUserPosition()
    if (useSettings().systemSettingsGetters) {
      if (useSettings().systemSettingsGetters && useSettings().systemSettingsGetters.avatar_voice_choice.choices) {
        useSettings().systemSettingsGetters.avatar_voice_choice.choices.forEach(choice => {
          let obj = {
            value: Object.keys(choice)[0],
            text: Object.values(choice)[0]
          }
          this.optionsVoice.push(obj)
        })
      }
    }

    if (useSettings().voiceGetters) {
      this.voiceSelected = useSettings().voiceGetters
    }
    useIntentStore().errorNetworkIntent = false
    this.tokenInterval = setInterval(this.generateToken, 3600000);
    this.generateToken();
    this.emitter.on('confirmInit', (bool) => {
      this.confirmToSpeak = bool
    })
    // event ascoltato dal fake component quando si accede con spid
    // this.emitter.on('sendDetectIntent', () => {
    //  this.boolcustom = true
    //  this.getResponseHttp('Esempio certificato anagrafico');
    // })
  },
  mounted() {
    let container_content_chat = document.getElementById('container-content-chat')
    let form_custom = document.getElementsByTagName('form')[0]
    if (container_content_chat) {
      container_content_chat.style.height = 'calc(95vh - ' + form_custom.getBoundingClientRect().height + ')'
      container_content_chat.addEventListener('scroll', this.showIt);
    }

    this.recordBtn = document.querySelector(".record")
    let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition,
        recording = false;

    if (SpeechRecognition) {
      this.microphoneSupported = true
    } else {
      this.microphoneSupported = false
    }
    const that = this

    function speechToText() {
      try {
        that.recognition = new SpeechRecognition();
        that.recognition.interimResults = true;
        that.recognition.start();
        that.recognition.addEventListener('result', (event) => {
          const speechResult = event.results[0][0].transcript;
          console.log('speechResult', speechResult)
          console.log('event result', event)
          if (event.results[0].isFinal) {
            that.nome = speechResult + " ";
            stopRecording()
          } else {
            // that.nome = speechResult + " ";
          }
        })
        that.recognition.addEventListener('speechend', () => {
          console.error('SPEECH END')
        })
        that.recognition.addEventListener('error', (event) => {
          stopRecording();
          console.log('error')
          that.errorPermissions = true
          that.typePermissions = 'microphone'


          // if (event.error === "no-speech") {
          //   that.messageErrorPermissions = "Non è stata riconosciuta nessuna frase/parola o altro"
          // } else
          if (event.error === "audio-capture") {
            that.messageErrorPermissions = "Microfono non trovato"
          } else if (event.error === "not-allowed") {
            that.messageErrorPermissions = 'Attiva il microfono nel browser. ' + "<br>" +
                "Per parlare con l'avatar digitale vai su Impostazioni del sito > Microfono: Consenti"
          }
              // else if (event.error === "aborted") {
              //   that.messageErrorPermissions = "Listening Stopped."
          // }
          else {
            that.messageErrorPermissions = "Purtroppo qualcosa non ha funzionato." + "<br>" + "Contatta un amministratore di sistema"
          }
          setTimeout(() => {
            that.scrollDown()
          }, 500)
        })
      } catch (error) {
        recording = false;
      }
    }

    this.recordBtn.addEventListener("click", () => {
      console.log('recording', recording)
      if (!recording) {
        this.setAudio = true
        speechToText();
        recording = true;
      } else {
        this.setAudio = false
        stopRecording();
      }
    });

    function stopRecording() {
      that.recognition.stop();
      that.setAudio = false
      that.errorPermissions = false
      if (that.nome !== '') {
        useSettings().messages.push({
          owner: 'user',
          message: that.nome
        })
        that.getDetectIntent({text: {text: that.nome, languageCode: that.languageCode}})
      }
      that.nome = ''
      recording = false;
    }

  },
  watch: {
    errorPermissions: {
      handler: function (value) {
        if (value) {
          setTimeout(() => {
            this.errorPermissions = false
          }, 10000)
        }
      }
    },
    messages: {
      handler: function () {
        setTimeout(() => {
          this.scrollDown();
        }, 100)
      },
      deep: true
    },
    loading: {
      handler: function (value) {
        if (!value && this.confirmToSpeak) {
          let queryInputPayload = {
            event: {
              name: 'Welcome',
              parameters: {avatar_first_name: useSettings().systemSettingsGetters.avatar_first_name.value},
              languageCode: this.languageCode
            }
          }
          this.getDetectIntent(queryInputPayload)
          useSettings().isGenderModified = false
        }
      }
    },
    confirmToSpeak: {
      handler: function (value) {
        if (value && !useSettings().loadingGetters) {
          let queryInputPayload = {
            event: {
              name: 'Welcome',
              parameters: {avatar_first_name: useSettings().systemSettingsGetters.avatar_first_name.value},
              languageCode: this.languageCode
            }
          }
          this.getDetectIntent(queryInputPayload)
          useSettings().isGenderModified = false
        }
      }
    },
    objReceive: {
      handler: function (value) {
        if (value.queryResult.intent.displayName === 'form' && value) {
          setTimeout(() => {
            let allInputForm = document.querySelectorAll('.div-form1 input');
            for (let i = 0; i < allInputForm.length; i++) {
              let a = allInputForm[i].name
              this.objBuild[a] = allInputForm[i].value
              this.schema = object().shape({
                username: string().required('obbligatorio')
              })
            }
            let button
            button = document.getElementById('button-id')
            button.addEventListener('click', () => {
              for (let i = 0; i < allInputForm.length; i++) {
                let a = allInputForm[i].name
                this.objBuild[a] = allInputForm[i].value
                this.schema = {
                  a: allInputForm[i].value
                }
              }

            })

          }, 1000)
        }
      }
    },
    setMute: {
      handler: function (value) {
        if (value) {
          this.snd.muted = true
        } else {
          this.snd.muted = false
        }
      }
    }
  },
  updated() {
    let spanError = document.getElementById('text-error')
    if (spanError) {
      spanError.innerHTML = this.messageErrorPermissions
    }
  },
  computed: {
    loading() {
      return useSettings().loadingGetters
    },
    messages() {
      return useSettings().messagesGetters
    }
  },
  methods: {
    resetAllActions() {
      this.showActions = false
      this.showVoice = false
    },
    mouseOutFeedback(event) {
      if (event.target.nodeName === 'BUTTON')
        event.target.style.background = 'var(--color-light-grey)'
    },
    mouseInFeedback(event) {
      if (event.target.nodeName === 'BUTTON')
        event.target.style.background = 'var(--color-grey)'
    },
    showIt() {
      const toBeShown = document.querySelectorAll(".balloon"); // consider adding :not(.scrolled) to selector to reduce the number of iterations if you don't want to support scrolling up
      const container_content_single_chat_bot = document.querySelectorAll(".container-content-single-chat-bot"); // consider adding :not(.scrolled) to selector to reduce the number of iterations if you don't want to support scrolling up
      let halfScreen
      if (useApiSettingStore().isMobileGetters) {
        halfScreen = window.innerHeight / 2;
      } else {
        halfScreen = 150
      }
      console.log(halfScreen)
      // let forceBottom = 50
      if (toBeShown && container_content_single_chat_bot) {
        if (!useApiSettingStore().isMobileGetters) {
          container_content_single_chat_bot.forEach((item, i) => {
            if (item.getBoundingClientRect().bottom < halfScreen) {
              toBeShown[i].classList.add('scrolled');
            } else {
              if (toBeShown[i] !== undefined && toBeShown[i].classList.contains('scrolled'))
                toBeShown[i].classList.remove('scrolled');
            }
          })
        } else {
          toBeShown.forEach((item) => {
            if (item.getBoundingClientRect().bottom - 50 < halfScreen + 50) {
              item.classList.add('scrolled');
            } else {
              if (item !== undefined && item.classList.contains('scrolled'))
                item.classList.remove('scrolled');
            }
          })
        }
      }
    },
    getUserPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
              this.userPosition = position
            },
            () => {
              this.typePermissions = 'position'
              this.errorPermissions = true
              this.messageErrorPermissions = "Attiva la posizione nel browser." + "<br>" +
                  "Per ricevere informazioni su mappe e percorsi vicino a te vai nelle Impostazioni del sito > Posizione: Consenti"
            },
            {enableHighAccuracy: true});
      }
    },
    getEmbeddedMapSrc(embedded_map) {
      let type_map = embedded_map.type_map
      let params = new URLSearchParams()
      params.append('key', 'AIzaSyAtvLYJu1X1CqnjNT1n7ZwxFj1xgezbOwQ')
      if (embedded_map.zoom) {
        params.append('zoom', embedded_map.zoom)
      }
      if (embedded_map.type_map === 'directions') {
        params.append('destination', embedded_map.destination)
        if (embedded_map.mode)
          params.append('mode', embedded_map.mode)
        if (embedded_map.origin) {
          params.append('origin', embedded_map.origin)
        } else {
          let origin
          if (this.userPosition) {
            origin = this.userPosition.coords.latitude + "," + this.userPosition.coords.longitude
            params.append('origin', origin)
          } else {
            params.append('q', embedded_map.destination)
            type_map = 'place'
            params.delete('destination')
            params.delete('mode')
          }
        }
      } else {
        params.append('q', embedded_map.q)
      }
      return "https://www.google.com/maps/embed/v1/" + type_map + "?" + params
    },
    createFeedback(values, actions) {
      actions.resetForm()
      useFeedbackStore().createFeedback(this.objFeedback)
          .then(() => {
            useSettings().messages.push({
              owner: 'bot',
              message: 'Feedback inviato con successo',
            });
            this.objFeedback.value = null
            this.objFeedback.comment = ''
            let container_feedback = document.getElementsByClassName('container-feedback')
            for (let i = 0; i < container_feedback.length; i++) {
              container_feedback[i].style.opacity = '0.5'
              let btn_feedback = document.getElementsByClassName('btn-feedback')[0]
              btn_feedback.disabled = true
              let container_icons_feedback = document.getElementsByClassName('container-icons-feedback')[0]
              let textarea = document.getElementsByTagName('textarea')[0]
              textarea.disabled = true
              container_icons_feedback.childNodes.forEach(button => {
                button.disabled = true
              })
            }
          }, reason => {
            actions.setErrors(reason.response.data)
          })
          .catch(() => {
          })
    },
    setFeedBack(value) {
      this.objFeedback.value = value
    },
    changeVoice(voice) {
      useSettings().voice = voice
    },
    updateSetting(gender) {
      useSettings().gender = gender
      // update voice in local when user change gender
      if (gender === 'f'){
        useSettings().voice = 'it-IT-Wavenet-B'
      } else if (gender === 'm'){
        useSettings().voice = 'it-IT-Wavenet-C'
      }
    },
    resetColor() {
      this.color = '#99A6AA'
    },
    setColor() {
      this.color = '#5090A5'
    },
    async downloadItem({url, label}) {
      delete axios.defaults.headers.common['Authorization']
      const response = await axios.get(url, {responseType: "blob"});
      const blob = new Blob([response.data], {type: response.data.type});
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    setterMute(bool) {
      this.setMute = bool
    },
    // showedSpid() {
    //  useSettings().showFakeComponent = true
    // },

    // eslint-disable-next-line no-unused-vars
    async onSubmit() {
      let buttons = document.getElementsByClassName('buttons')
      if (buttons) {
        for (let i = 0; i < buttons.length; i++) {
          for (let k = 0; k < buttons[i].children.length; k++) {
            buttons[i].children[k].disabled = true
          }
        }
      }
      if (this.allowRequest && this.nome !== '') {
        await this.getResponseHttp(this.nome);
      }
    },
    async sendButton(event, btn) {
      let buttons = event.target.parentElement.children
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true
      }

      // TODO hardcoded
      // if (btn === 'Esempio certificato anagrafico') {
      //  this.boolSpid = true
      //  this.lastNome = this.nome;
      //  this.nome = "";
      //  useSettings().messages.push({
      //   owner: 'user',
      //   message: btn
      // });
      //}
      // else
      if (this.allowRequest && btn !== '') {
        await this.getResponseHttp(btn);
      }
    },
    scrollDown() {
      let div = document.getElementsByClassName('container-content-chat')[0];
      if (div) {
        div.style.scrollbarWidth = '0px';
        div.scrollTo(0, div.scrollHeight);
      }
    },
    async cleanFields($id) {
      this.formData[$id] = {};
    },
    disabledButton(event) {
      event.target.parentElement.parentElement.parentElement.style.opacity = 0.5
      let buttons = event.target.parentElement.children
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true
      }
    },
    annullaForm(event) {
      this.disabledButton(event)
      this.addToChat("bot", 'Form annullato', [], this.response);
      this.getDetectIntent({event: {name: 'fallback-after-end-interaction', languageCode: this.languageCode}})
    },
    async sendFields($id) {
      let res = [];
      let array = document.getElementsByClassName('form_' + $id)

      // oscura tutti i form
      for (let i = 0; i < array.length; i++) {
        array[i].style.opacity = 0.5
        if (array[i].tagName === 'BUTTON') {
          array[i].disabled = true
        }
      }
      let $records = await this.prepareRecords($id, this.formData[$id]);
      await useFormStore().sendFormRecords($records)
          .then((response) => {
            res = response.data;
            this.acceptForm("Inviato con successo", this.formData[$id]);
            this.getDetectIntent({event: {name: 'fallback-after-end-interaction', languageCode: this.languageCode}})
          })
          .catch(() => {
            this.getDetectIntent({event: {name: 'fallback-after-end-interaction', languageCode: this.languageCode}})
          }, this);

      return res;
    },
    async prepareRecords($id, $records) {
      let records = {};
      records["form"] = $id;
      records["field_records"] = [];
      for (const property in $records) {
        let tempRecord = {};
        let input = document.getElementById(property + 'input');
        switch (input.type) {
            // case "text":
            // case "numeric":
            // case "date":
            // case "time":
            // case "datetime":
            // case "email":
            // case "select-one":
            //   break;
          case "file":
            var file = input.files[0];
            if (file && file !== undefined) {
              if (file.size > 5e+8 && file) {
                this.errorForm("troppo pesante");
              }
              tempRecord["data"] = {};
              tempRecord["data"]["file"] = {};
              tempRecord["data"]["file"]["file_name"] = file.name;
              await this.getBase64(file).then(function (data) {
                    tempRecord["data"]["file"]["data"] = data;
                  }
              );
            } else {
              tempRecord["data"] = {};
              tempRecord["data"]["file"] = null
            }
            break;
          case "checkbox":
            tempRecord["data"] = {};
            tempRecord["data"]["choices"] = $records[property] != "" ? $records[property] : [];
            break;
          default:
            tempRecord["data"] = $records[property];
            break;
        }

        tempRecord["field"] = property;
        records["field_records"].push(tempRecord);
      }
      return records;
    },
    errorForm(msn) {
      this.addToChat("bot", msn, [], this.response);
    },
    checkIsForm() {
      let bool = false
      this.lastFulfillmentMessages.forEach(message => {
        if ('payload' in message) {
          if ('intent_type' in message.payload) {
            if (message.payload.intent_type === 'form') {
              bool = true
            }
          }
        }
      })
      return bool
    },
    acceptForm(msn, data) {
      Object.keys(data).forEach(key => {
        document.getElementById(key + 'input').disabled = true;
      })
      this.addToChat("bot", msn, [], this.response);
    },
    sendTimeline() {
      var timelineSend = {
        'user_id': useApiSettingStore().sessionIDGetters,
        'session_id': useApiSettingStore().userIDGetters,
        'timeline': JSON.stringify((useSettings().messagesGetters)),
      };
      // useSettings().messages
      console.log(timelineSend)
    },
    async getResponseHttp(text) {
      useIntentStore().errorNetworkIntent = false
      if (!this.boolcustom) {
        this.lastNome = this.nome;
        this.nome = "";
        useSettings().messages.push({
          owner: 'user',
          message: text
        });
      }

      if (!useAuthStore().bearerTokenJWTGetters) {
        setTimeout(this.detectIntent, 300, this.response, this.languageCode);
        return;
      }
      if (this.lastIntent) {
        if ('endInteraction' in this.lastIntent) {
          this.objFeedback.comment = ''
          this.objFeedback.value = null
          let container_feedback = document.getElementsByClassName('container-feedback')
          for (let i = 0; i < container_feedback.length; i++) {
            container_feedback[i].style.opacity = '0.5'
            let btn_feedback = document.getElementsByClassName('btn-feedback')[0]
            btn_feedback.disabled = true
            let container_icons_feedback = document.getElementsByClassName('container-icons-feedback')[0]
            let textarea = document.getElementsByTagName('textarea')[0]
            textarea.disabled = true
            container_icons_feedback.childNodes.forEach(button => {
              button.disabled = true
            })
          }

          if (this.lastIntent.endInteraction && text.toLowerCase() === 'si') {
            text = 'Ciao!'
            this.feedback = false
          } else if (this.lastIntent.endInteraction && text.toLowerCase() === 'no') {
            this.feedback = true
          }
        }
      }

      if (!this.feedback) {

        await this.getDetectIntent({text: {text: text, languageCode: this.languageCode}})
            .then(res => {
              this.lastIntent = res.data.queryResult.intent
            })
            .catch(() => {
            })

      } else {
        useSettings().messages.push({
          owner: 'bot',
          message: 'Scegli l’icona che rappresenta il tuo grado di soddisfazione con l’avatar digitale',
          extra: {
            feedback: true
          }
        });
        this.feedback = false
      }
    },
    getDetectIntent(queryInputPayload) {
      return new Promise((resolve, reject) => {
        const session = "projects/" + useSettings().serviceAccountCredentialsGetters.setting_records.project_id.value + "/agent/sessions/" + useApiSettingStore().sessionIDGetters;
        this.canWrite = false
        let payload = {
          queryInput: queryInputPayload,
          outputAudioConfig: {
            audioEncoding: 'OUTPUT_AUDIO_ENCODING_LINEAR_16',
            sampleRateHertz: 44000,
            synthesizeSpeechConfig: {
              speakingRate: 1,
              pitch: 0,
              volumeGainDb: 0,
              voice: {
                name: useSettings().voiceGetters
              }
            }
          }
        };


        const that = this;
        this.spinner = true
        axios.defaults.baseURL = "https://dialogflow.googleapis.com";
        axios.defaults.headers.common["Authorization"] = "Bearer " + useAuthStore().bearerTokenJWTGetters;

        axios
            .post("/v2/" + session + ":detectIntent", payload)
            .then(response => {
              console.log('intent detect', response.data.queryResult.intent)
              console.log('response.data.queryResult.fulfillmentMessages', response.data.queryResult.fulfillmentMessages)
              that.spinner = false;
              that.canWrite = true;
              // that.boolSpid = false;
              that.boolcustom = false;
              that.feedback = false;
              that.lastIntent = response.data.queryResult.intent
              that.lastFulfillmentMessages = response.data.queryResult.fulfillmentMessages
              that.response = response.data;
              this.parseResponseSpecial(that.response);
              useSettings().loading = false;
              resolve(response)
            })
            .catch(() => {
              that.canWrite = true;
              reject()
            });

      })
    },
    async parseResponseSpecial($response) {
      let extra = {};
      let payload = [];
      try {
        this.playAudioCustom($response.outputAudio);
        if ($response.queryResult.fulfillmentMessages.length > 1) {
          payload = $response.queryResult.fulfillmentMessages[1].payload;
          extra = {
            "default_responses": payload.default_responses
          };
          if ('formid' in payload) {
            extra["form"] = this.prepareFormResponse(await this.responseForm(payload.formid))
          }
          if ('intent_type' in payload) {
            if (payload.intent_type === 'document') {
              extra["documents"] = this.prepareDocumentResponse(await this.responseDocument($response.queryResult.intent))
            }
          }
          if ('news' in payload) {
            extra["news"] = []
          }
          if ('youtube_video_id' in payload) {
            extra["youtube_video_id"] = payload.youtube_video_id
          }
          if ('embedded_map' in payload) {
            extra["embedded_map"] = payload.embedded_map
          }

        }
        if ($response.queryResult.fulfillmentText.length > 120) {
          extra['read_more'] = true
        }
        console.log(extra)
        if ('fulfillmentText' in $response.queryResult) {
          if ($response.queryResult.fulfillmentText.length > 120) {
            extra['read_more'] = true
          }
          await this.addToChat("bot", $response.queryResult.fulfillmentText, extra, $response);
        } else {
          this.getDetectIntent({event: {name: 'default-fallback-intent', languageCode: this.languageCode}})
        }
      } catch (e) {
        //
      }
    },
    async addToChat($owner, $message, $extra = [], $response) {

      $response.queryResult.fulfillmentMessages.forEach(el => {
        if ('payload' in el) {
          if ('links' in el.payload) {
            let offset = 0
            el.payload.links.forEach(link => {
              let message_match = $message.substring(link.start + offset, link.end + offset)
              if (link.key === message_match) {
                let replaced = '<a target="_blank" href="' + link.link + '">' + link.key + '</a>'
                let initial_substring = $message.substring(0, link.start + offset)
                let final_substring = $message.substring((link.end + offset), $message.length)
                $message = initial_substring + replaced + final_substring
                offset = offset + replaced.length - message_match.length
              }
            })
          }
        }
      })
      let newsIsPresent = false
      let link
      $response.queryResult.fulfillmentMessages.forEach(el => {
        if ('payload' in el) {
          if ('news' in el.payload) {
            newsIsPresent = true
            link = el.payload.news
          }
        }
      })


      if ('read_more' in $extra) {
        $extra['index'] = useSettings().messagesGetters.length
      }
      console.log('$extra', $extra)

      if (!newsIsPresent) {
        useSettings().messages.push({
          owner: $owner,
          message: $message,
          extra: $extra.length === 0 ? undefined : $extra
        });
      } else {
        let queryParams = {
          news: link
        }
        useUtilsStore().getUtils({queryParams: queryParams, utils_type: 'news'})
            .then(res => {
              $extra.news = res.data
              useSettings().messages.push({
                owner: $owner,
                message: $message,
                extra: $extra.length === 0 ? undefined : $extra
              });
            })
            .catch(() => {
            })
      }
    },
    getInputType(type) {
      let typeF = "text";
      switch (type) {
        case "t":
          typeF = "text";
          break;
        case "nm":
          typeF = "number";
          break;
        case "dt":
          typeF = "date";
          break;
        case "tm":
          typeF = "time";
          break;
        case "dttm":
          typeF = "datetime-local";
          break;
        case "f":
          typeF = "file";
          break;
        case "c":
          typeF = "radio";
          break;
        case "mc":
          typeF = "checkbox";
          break;
        case "e":
          typeF = "email";
          break;
        default:
      }
      return typeF;
    },
    getDBType(type) {
      let typeDB = "t";
      switch (type) {
        case "text":
          typeDB = "t";
          break;
        case "number":
          typeDB = "nm";
          break;
        case "date":
          typeDB = "dt";
          break;
        case "time":
          typeDB = "tm";
          break;
        case "datetime-local":
          typeDB = "dttm";
          break;
        case "file":
          typeDB = "f";
          break;
        case "select-one":
          typeDB = "c";
          break;
        case "checkbox":
          typeDB = "mc";
          break;
        case "email":
          typeDB = "e";
          break;
        default:
      }
      return typeDB;
    },
    async responseForm(name) {
      let res = [];
      await useFormStore().getFormByName(name)
          .then((response) => {
            res = response.data;
          })
          .catch(() => {
          });
      return res;
    },
    async responseDocument(intent) {
      let intent_id = intent.name.split('/')[4]
      let res = [];
      let queryParams = {
        intent_id: intent_id
      }
      console.log(intent_id)
      await useDocumentStore().getDocuments({queryParams: queryParams})
          .then((response) => {
            res = response.data;
          })
          .catch(() => {
          });
      return res;
    },
    prepareFormResponse($formResponse) {
      $formResponse.results.forEach(function (form, indexF) {
        this.formData[form.id] = {};
        let tempFields = [];
        form.fields.forEach(function (field) {
          this.formData[form.id][field.id] = "";
          if (tempFields[field.row] === undefined) tempFields[field.row] = [];
          let tempField = field;
          tempFields[field.row][field.col] = tempField;
        }, this);
        $formResponse.results[indexF].fields = tempFields;
      }, this);
      return $formResponse;
    },
    prepareDocumentResponse($documentResponse) {
      return $documentResponse;
    },
    playAudioCustom($base64string) {
      if (this.snd === null) {
        this.snd = new Audio("data:audio/wav;base64," + $base64string);
        this.snd.play();
        if (this.setMute) {
          this.snd.muted = true
        }
        this.$emit('setStatusAnimationSpeech', true);
        const that = this;
        this.snd.onended = function () {
          that.$emit('setStatusAnimationSpeech', false);
          if (that.lastIntent.endInteraction && that.lastIntent.displayName !== 'fallback-after-end-interaction' && !that.checkIsForm()) {
            that.getDetectIntent({event: {name: 'fallback-after-end-interaction', languageCode: that.languageCode}})
          }
        };
      } else {
        this.snd.pause();
        this.snd = new Audio("data:audio/wav;base64," + $base64string);
        this.snd.play()
        if (this.setMute) {
          this.snd.muted = true
        }
        this.$emit('setStatusAnimationSpeech', true);
        const that = this;
        this.snd.onended = function () {
          that.$emit('setStatusAnimationSpeech', false);
          if (that.lastIntent.endInteraction && that.lastIntent.displayName !== 'fallback-after-end-interaction' && !that.checkIsForm()) {
            that.getDetectIntent({event: {name: 'fallback-after-end-interaction', languageCode: that.languageCode}})
          }
        };
      }
    },
    generateToken() {
      const header = {
        alg: "RS256",
        typ: "JWT",
        kid: useSettings().serviceAccountCredentialsGetters.setting_records.private_key_id.value,
      };

      const payload = {
        iss: useSettings().serviceAccountCredentialsGetters.setting_records.client_email.value,
        sub: useSettings().serviceAccountCredentialsGetters.setting_records.client_email.value,
        iat: KJUR.jws.IntDate.get("now"),
        exp: KJUR.jws.IntDate.get("now + 1hour"),
        aud: "https://dialogflow.googleapis.com/google.cloud.dialogflow.v2.Sessions",
      };

      const stringHeader = JSON.stringify(header);
      const stringPayload = JSON.stringify(payload);
      useAuthStore().bearerTokenJWT = KJUR.jws.JWS.sign(
          "RS256",
          stringHeader,
          stringPayload,
          useSettings().serviceAccountCredentialsGetters.setting_records.private_key.value
      );
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
  },
  beforeUnmount() {
    if (this.recognition) {
      this.recognition.removeEventListener('result', () => {
      })
      this.recognition.removeEventListener('error', () => {
      })
      this.recognition.removeEventListener('speechend', () => {
      })
    }
    this.recordBtn.removeEventListener('click', () => {
    })
    window.removeEventListener('scroll', this.showIt);
    // useSettings().showFakeComponent = false
    this.emitter.off('confirmInit', () => {
    })
  },
  unmounted() {
    if (this.recognition) {
      this.recognition.removeEventListener('result', () => {
      })
      this.recognition.removeEventListener('error', () => {
      })
      this.recognition.removeEventListener('speechend', () => {
      })
    }
    this.recordBtn.removeEventListener('click', () => {
    })
    this.emitter.off('confirmInit', () => {
    })
  }
}
</script>

<style scoped>
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 16px;
  line-height: 24px;

  color: var(--color-grey);
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */

  color: var(--color-grey) !important;
}

::-ms-input-placeholder { /* Microsoft Edge */

  color: var(--color-grey) !important;
}

.container-error-network img {
  margin-right: 10px;
}

.btn-send.btn {
  background: var(--color-dark-blue);
  border: 2px solid var(--color-light-blue);
  border-radius: 8px;
  font-style: normal;
  font-weight: var(--font-weight-bold);
  font-size: 16px;
  line-height: 24px;
  color: var(--color-white);
}

.btn-clear.btn {
  background: var(--color-dark-blue);
  border: 2px solid var(--color-danger);
  border-radius: 8px;
  font-style: normal;
  font-weight: var(--font-weight-bold);
  font-size: 16px;
  line-height: 24px;
  color: var(--color-white);
  margin-right: 10px;
}

.btn:hover {
  background: var(--color-black);
}

.btn-default-responses.btn {
  text-align: left;
  background: var(--color-dark-blue);
  border: 2px solid var(--color-light-blue);
  border-radius: 8px;
  font-style: normal;
  font-weight: var(--font-weight-bold);
  font-size: 16px;
  line-height: 24px;
  color: var(--color-white) !important;
  margin-right: 10px;
  display: flex;
  margin-bottom: 5px;
  word-break: break-all;
  align-items: center;
  text-align: left;
  width: auto;
}

.there_is_buttons {
  margin: 5px 0px 0px 0px;
}

.buttons {
  display: flex;
  flex-wrap: wrap;
}

.container-error-network {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin: 0px auto;
  background: rgba(13, 24, 26, 0.5);
  border-radius: 8px;
  padding: 10px 15px;
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 16px;
  line-height: 24px;
  color: var(--color-white);
}

.form-control-chat {
  box-shadow: unset;
  padding: 10px 50px !important;
  background: #FFFCFF !important;
  border: 1px solid #99A6AA !important;
  border-radius: 8px !important;
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 16px !important;
  color: var(--color-black);
  height: 100%;
}

.container-actions img {
  width: 25px;
  margin: 0px 7.5px;
  height: 25px;
  cursor: pointer;
}

.container-content-actions {
  display: flex;
  align-items: center;
  width: 100%;
}

#container-actions {
  transition: opacity 1s ease-in-out;
  opacity: 0;
  height: 0;
  overflow: hidden;
  width: 0;
  padding: 0;
}

#container-actions.isOpen {
  opacity: 1;
  width: auto;
  padding: 10px;
  overflow: unset;
  height: auto;
}


.text-field {
  font-style: normal;
  font-weight: var(--font-weight-bold);
  font-size: 16px;
  line-height: 24px;
  color: var(--color-white);
}

.container-actions, .container-more {
  display: flex;
  align-items: center;
  padding: 10px;
  width: auto;
  margin-right: 10px;
  background: #EAEDEE;
  border-radius: 8px;
}

.container-more img {
  cursor: pointer;
}

.form-group {
  margin: 0px;
  width: 100%;
}

.btn-submit {
  border: unset !important;
  background: transparent !important;
  position: absolute;
  right: 0;
  padding: 0px !important;
  top: 50%;
  transform: translate(-50%, -50%);
}


.container-all-news::-webkit-scrollbar {
  width: 10px;
}

.container-all-news::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  background: #99A6AA;
  border-radius: 2px;
}

.container-all-news::-webkit-scrollbar-thumb {
  background: #0D181A;
  border-radius: 2px;
}

.container-content-news-mobile::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.container-content-news-mobile::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  background: #99A6AA;
  border-radius: 2px;
}

.container-content-news-mobile::-webkit-scrollbar-thumb {
  background: #0D181A;
  border-radius: 2px;
}

.container-content-default-response-mobile::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.container-content-default-response-mobile::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  background: #99A6AA;
  border-radius: 2px;
}

.container-content-default-response-mobile::-webkit-scrollbar-thumb {
  background: #0D181A;
  border-radius: 2px;
}

.container-all-news {
  display: flex;
  margin-top: 10px;
  flex-direction: column;
  max-height: 450px;
  overflow: auto;
}

.text-news {
  margin: 10px;
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #FFFCFF;
}

.form-group-custom {
  margin-left: auto;
  max-width: 85%;
}

.img-news {
  max-width: 100px;
  min-width: 100px;
  width: 100% !important;
  max-height: 60px;
  min-height: 60px;
  height: 100% !important;
  object-fit: cover;
}

.container-news:hover {
  text-decoration: underline !important;
}

.container-news {
  display: flex;
  text-decoration: unset !important;
  align-items: center;
  margin: 10px 10px 10px 0px;
  padding: 0px 5px;
  background: #0D181A;
  border-radius: 5px;
}

.btn-audio {
  border: unset !important;
  background: transparent !important;
  position: absolute;
  left: 0;
  padding: 0px !important;
  top: 50%;
  transform: translate(50%, -50%);
}

.btn-annulla.btn-clear {
  float: right;
}

.container-content-chat::-webkit-scrollbar {
  width: 0px;
}

/*.container-content-chat::-webkit-scrollbar-track {*/
/*  box-shadow: inset 0 0 5px grey;*/
/*  background: #99A6AA;*/
/*  border-radius: 2px;*/
/*}*/

/*.container-content-chat::-webkit-scrollbar-thumb {*/
/*  background: #0D181A;*/
/*  border-radius: 2px;*/
/*}*/


.form-mio {
  background: red;
}

.container_content_single_chat_user.container-content-single-chat-bot {
  display: flex;
  position: relative;
  margin-left: auto !important;
  margin-right: 0px !important;
  background: #FFFCFF !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 10px !important;
  box-shadow: 0px 4px 4px rgba(152, 205, 217, 0.3) !important;
  color: var(--color-black);
}

.form-container {
  align-items: flex-end;
}

.container_content_single_chat_user.container-content-single-chat-bot::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 0;
  left: calc(100% - 10px);
  border-width: 10px;
  border-right: 0px !important;
  border-style: solid;
  border-color: #FFFCFF transparent transparent transparent !important;
}

.row-custom {
  align-items: end;
}

.btn-feedback.btn-primary-custom-colors-dark.btn-primary-custom.btn {
  border: 2px solid var(--color-white);
  margin: 10px 0px 10px 0px;
}


.container_single_icon_feedback_0.container-single-icon-feedback {
  background: var(--color-danger) !important;
}

.container_single_icon_feedback_1.container-single-icon-feedback {
  background: var(--color-orange) !important;
}

.container_single_icon_feedback_2.container-single-icon-feedback {
  background: var(--color-yellow) !important;
}

.container_single_icon_feedback_3.container-single-icon-feedback {
  background: var(--color-light-green) !important;
}

.container_single_icon_feedback_4.container-single-icon-feedback {
  background: var(--color-success) !important;
}

.container-feedback {
  display: flex;
  flex-direction: column;
  margin: 0px !important;
}

/*.container-single-icon-feedbaccontainer-single-icon-feedback:hover {*/
/*  background: var(--color-grey);*/
/*}*/

.container-icons-feedback {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 15px 0px;
}

.container-single-icon-feedback {
  display: flex;
  cursor: pointer;
  align-items: center;
  margin-bottom: 5px;
  min-width: 40px;
  margin-right: 10px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;
  border: unset !important;
  background: var(--color-light-grey);
  justify-content: center;
  border-radius: 8px;

}

.bv-no-focus-ring {
  display: flex;
  flex-direction: column;
}

.reset_max_width.container-content-single-chat-bot {
  max-width: 95%;
}

.container-content-single-chat-bot {
  /*display: flex;*/
  padding: 15px;
  max-width: 70%;
  color: #FFFCFF;
  margin: 10px auto 10px 0px;
  background: #f9f9f9;
  border-radius: 10px;
  background: var(--color-dark-blue);
  box-shadow: 0px 4px 4px rgba(13, 24, 26, 0.3);
  position: relative;
  border-bottom-left-radius: 0px;
}

:deep(.form-check-inline) {
  margin: 5px 10px;
}

.container_menu {
  position: absolute;
  bottom: 10vh;
  background: #fff;
  border-radius: 10px;
  display: block;
}

.form-check-label-voice {
  color: var(--color-black);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 14px !important;
  margin-left: 5px;
}

:deep(.form-check-input) {
  margin-top: 0px;
}

:deep(.btn-secondary) {
  border: unset !important;
}

img {
  width: 24px !important;
  height: 24px !important;
}

:deep(.dropdown-toggle) {
  background: unset !important;
}

:deep(.dropdown-toggle)::after {
  display: unset !important;
  border: unset !important;
}

.container-documents {
  display: flex;
  flex-wrap: wrap;
}

.img-downlaod {
  margin-left: 15px;
}

.container_button_spids {
  margin: 20px 0px;
}

#text-error {
  margin: 0px 5px;
}

.container-button-spids {
  display: flex;
  flex-wrap: wrap;
}

.btn-spid.btn img {
  margin-right: 15px;
}

.btn-spid.btn {
  margin-right: 15px;
  background: #0073E6;
  border: 2px solid var(--color-white);
  border-radius: 8px;
  font-style: normal;
  font-weight: var(--font-weight-bold);
  font-size: 16px;
  line-height: 24px;
  color: var(--color-white)
}

.container-content-single-chat-bot::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: calc(100% - 10px);
  border-width: 10px;
  border-left: 0px;
  border-style: solid;
  border-color: var(--color-dark-blue) transparent transparent transparent;
}

.form_with_chat_hide {
  margin-top: auto !important;
}

.container-content-chat {
  overflow: auto;
  margin: auto 0px 0px 0px;
  display: flex;
  position: relative;
  scroll-behavior: smooth;
  flex-direction: column;
  scroll-behavior: smooth;
}

.container-custom-radio-button {
  width: auto;
}

.container-gender-voice {
  display: flex;
  align-items: center;
}

.container-checkbox label {
  margin-left: 5px !important;
  color: var(--color-white)
}

.container-checkbox {
  display: flex;
  align-items: center;
  margin: 2.5px 0px;
}

.text-news-mobile {
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: var(--color-black);
}


/*.container-single-news-mobile {*/
/*  background: var(--color-white);*/
/*  border: 2px solid var(--color-light-blue);*/
/*  border-radius: 5px;*/
/*  display: flex;*/
/*  margin-right: 20px;*/
/*}*/

.container-news-mobile {
  max-width: 95%;
  height: 100px;
  margin: 10px 0px;
  display: flex;
  align-items: center;
}

.container-default-responses-mobile {
  max-width: 95%;
  height: 55px;
  margin: 10px 0px;
  display: flex;
}

.container_content_single_chat_user_feedback_width.container-content-single-chat-bot{
  max-width: 100%;
}

.text-more:hover {
  cursor: pointer;
}

.text-more {
  cursor: auto;
  color: var(--color-light-blue);
  font-size: 14px;
  font-weight: var(--font-weight-regular);
  font-style: normal;
}

.container-message-more {
  max-height: unset;
  overflow: unset;
  position: relative;
}

.container-chat {
  right: 0;
  position: fixed;
  order: 2;
  background: rgba(13, 24, 26, 0.3);
  -webkit-backdrop-filter: blur(15px);
  backdrop-filter: blur(15px);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 35vw;
}

.container_chat.container-chat {
  width: 50vw;
  background: rgba(13, 24, 26, 0.3);
  backdrop-filter: blur(15px);
}

.max_height {
  overflow: hidden !important;
  max-height: 100px !important;
}

#container-content-chat {
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 20px
}

.container-single-message {
  display: flex;
  flex-direction: column;
}

.form-custom {
  width: 100%;
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0px;
  /*backdrop-filter: blur(15px);*/
  background: #2C3344FF;
}

.form {
  display: flex;
  flex-direction: column;
}

form {
  display: flex;
  flex-direction: row;
  margin: 20px;
}

h3 {
  margin: 0;
}

.transparent-spacing {
  min-height: 3000px;
}

.text-headline {
  overflow: hidden;
  height: 100%;
  margin-left: 10px;
}

.container-content-news-mobile {
  width: 100%;
  height: 100px;
  overflow-x: scroll;
  white-space: nowrap;
}

.btn-default-responses-mobile.btn-default-responses {
  display: inline;
}

.container-content-default-response-mobile {
  width: 100%;
  height: 55px;
  overflow-x: auto;
  white-space: nowrap;
}

.container-single-news-mobile {
  font-style: normal;
  font-weight: var(--font-weight-regular) !important;
  font-size: 14px !important;
  color: var(--color-black) !important;
}

.container-single-news-mobile {
  padding: 10px;
  display: inline-block;
  width: 85%;
  margin-right: 20px;
  height: 70px;
  text-align: left;
  background: var(--color-white);
  border: 2px solid var(--color-light-blue);
  border-radius: 5px;
  white-space: normal;
  overflow: hidden;
}

.balloon.scrolled {
  opacity: 0;
}

.balloon {
  display: inline-block;
  opacity: 1;
  transition: opacity .3s ease-in-out;
}

:deep(.form-check-label) {
  margin-left: 5px !important;
  white-space: nowrap !important;
}

.container_all_news.container-all-news {
  max-height: 220px;
}

.img_news.img-news {
  display: none;
}

:deep(.form-check-inline) {
  display: flex;
  align-items: center;
}


/*// X-Small devices (portrait phones, less than 576px)*/
@media (max-width: 575.98px) {

}

/*// Small devices (landscape phones, less than 768px)*/
@media (max-width: 767.98px) {
  .container-single-icon-feedback img {
    width: 18px !important;
  }

  #container-content-chat {
    width: 100vw !important;
  }

  .container-single-icon-feedback {
    max-width: 32px;
    min-width: 32px;
    max-height: 32px;
    min-height: 32px;
  }

  .container-content-single-chat-bot, .reset_max_width.container-content-single-chat-bot {
    max-width: 85%;
  }
}

/*// Medium devices (tablets, less than 992px)*/
@media (max-width: 991.98px) {
  #container-actions.isOpen {
    max-width: 44px;
    position: absolute;
    margin-right: 20px;
  }

  .container-chat {
    background: unset;
    backdrop-filter: unset;
    width: 100vw;
  }

  .container-gender-voice {
    display: unset;
  }

  .container-content-actions {
    flex-wrap: wrap;
    display: unset;
  }

  .container-content-actions img {
    margin: 10px 0px;
  }

  .img-close {
    margin-bottom: 0px !important;
  }

  .form-group-custom {
    max-width: 80%;
  }

  .container-actions, .container-more {
    margin-right: 0px;
  }
}

/*// Large devices (desktops, less than 1200px)*/
@media (max-width: 1199.98px) {
}

/*// X-Large devices (large desktops, less than 1400px)*/
@media (max-width: 1399.98px) {

}

</style>